export default __webpack_public_path__ + "static/media/cl-1.e3b1fdbe.png";